interface IconBookingStatusInfoOrangeOptions {
    cssClasses?: string
}

export function IconBookingStatusInfoOrange(props: IconBookingStatusInfoOrangeOptions) {
    return (
        <svg width="100%" height="100%" viewBox="0 0 67 67" version="1.1" xmlns="http://www.w3.org/2000/svg" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;" className={props?.cssClasses}>
            <g>
                <clipPath id="_clip1">
                    <rect x="0" y="0" width="66.667" height="66.667"/>
                </clipPath>
                <g clip-path="url(#_clip1)">
                    <path d="M33.333,66.667c-18.286,-0 -33.333,-15.048 -33.333,-33.334c-0,-18.286 15.047,-33.333 33.333,-33.333c18.286,-0 33.334,15.047 33.334,33.333c-0,18.286 -15.048,33.334 -33.334,33.334Zm0,-61.125c-0.014,-0 -0.027,-0 -0.041,-0c-15.246,-0 -27.792,12.545 -27.792,27.791c0,15.246 12.546,27.792 27.792,27.792c15.246,-0 27.791,-12.546 27.791,-27.792c0,-15.23 -12.519,-27.768 -27.75,-27.791Z" style="fill:#efaa00;fill-rule:nonzero;"/>
                    <path d="M33.333,50c-1.531,-0 -2.791,-1.26 -2.791,-2.792l-0,-16.666c0.171,-1.393 1.367,-2.452 2.771,-2.452c1.403,0 2.599,1.059 2.77,2.452l0,16.666c0.001,1.516 -1.234,2.769 -2.75,2.792Z" style="fill:#efaa00;fill-rule:nonzero;"/>
                    <path d="M33.333,22.208c1.532,0 2.792,-1.26 2.792,-2.791c-0,-1.532 -1.261,-2.792 -2.792,-2.792c-1.531,0 -2.792,1.26 -2.792,2.792c0,0.014 0,0.027 0.001,0.041c0.022,1.516 1.275,2.751 2.791,2.75Z" style="fill:#efaa00;fill-rule:nonzero;"/>
                </g>
            </g>
        </svg>
    );
}
